/**
 * Recado que o produtor manda para quem comprou o ingresso, junto com um link
 * opcional. Sai no e-mail de pedido aprovado e nunca na página do evento.
 *
 * Os limites espelham a validação da API (products.buyer_message*).
 */
export const BUYER_MESSAGE_MAX_LENGTH = 1000;
export const BUYER_MESSAGE_LINK_LABEL_MAX_LENGTH = 80;

/**
 * A API só aceita http(s). Produtor costuma colar "chat.whatsapp.com/…" sem o
 * esquema, então completamos com https em vez de recusar.
 */
export function normalizeBuyerMessageLink(link) {
    const trimmed = (link || '').trim();

    if (!trimmed) return null;

    if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return trimmed;

    return `https://${trimmed}`;
}

export function isBuyerMessageLinkValid(link) {
    const normalized = normalizeBuyerMessageLink(link);

    if (!normalized) return true;

    try {
        const url = new URL(normalized);
        return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname.includes('.');
    } catch {
        return false;
    }
}

export function isBuyerMessageValid(ticket) {
    const message = ticket.buyer_message || '';
    const label = ticket.buyer_message_link_label || '';

    return (
        message.length <= BUYER_MESSAGE_MAX_LENGTH &&
        label.length <= BUYER_MESSAGE_LINK_LABEL_MAX_LENGTH &&
        isBuyerMessageLinkValid(ticket.buyer_message_link_url)
    );
}

/** Campos do recado prontos para o payload: vazio vira null, o link é normalizado. */
export function buyerMessagePayload(ticket) {
    const message = (ticket.buyer_message || '').trim();
    const link = normalizeBuyerMessageLink(ticket.buyer_message_link_url);
    const label = (ticket.buyer_message_link_label || '').trim();

    return {
        buyer_message: message || null,
        buyer_message_link_url: link,
        buyer_message_link_label: link && label ? label : null,
    };
}
